import { EVColors } from 'ev-theme/styles';

export const MuiDivider = {
  styleOverrides: {
    root: {
      borderBottom: `1px solid ${EVColors.silverBullet}`,
    },
  },
};
